import type { FaireProductEntity } from "../../entity_types/product";

export const p_udxksueucd: FaireProductEntity = {
  token: "p_udxksueucd",
  type: "product",
  name: "EMF 5G Pet Protection Orgonite Charm for Cats & Small Dogs",
  brandToken: "b_qpub74vn67",
  brandName: "Secret Synergy Stones",
  imageUrl:
    "https://cdn.faire.com/fastly/d133f23f4d83c9243a0cecc58849d706689f46bf7c07db2b0126744e138a633f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3ef372056dba150dfee4ae19f9d8b923ba5aa1c5cfea4d1ceb24396343d36473.jpeg",
    "https://cdn.faire.com/fastly/9fec49c10242883d8029a0c1a39edeadd7a57fdfed18656a05bed3f6228b5cbc.jpeg",
    "https://cdn.faire.com/fastly/f3114b59e488e0e0a52a190b0e5b5b7dd4058c0edd713a5949c80be5c71d279a.jpeg",
    "https://cdn.faire.com/fastly/a72c218ae56d140beea9e3abd8d8fbaf5c8d4a12437e737bd4face83bdd14222.jpeg",
    "https://cdn.faire.com/fastly/ea3a9de9e07e7096a549288ea833d5ac48984b0879a94e32bb3eff9c98e53761.jpeg",
    "https://cdn.faire.com/fastly/8b55b45d67df9cea2da396b2c8dd4513528072338cf124285a9f1c31ff61efc9.jpeg",
  ],
  priceDollars: 20.79,
  description:
    "EMF 5G Protection Cat & Dog Charm for under 30 lbs with Orgone, Shungite, Black Tourmaline & Rose Quartz plus Secret Synergy Proprietary Blend of Healing Crystals for Stunning Holistic Harmony.\n\nOur combining of these Synergy Stones provides THE STRONGEST protection available.\n\nHand Made with Genuine Stones in the U.S.A. Boost your pets health with the power of Secret Synergy Stones.\n\n24/7 Protection from possible Wi-Fi exposures. Ever Lasting Positive Energy. Extremely Durable/Strong construction.\n\nMay relieve Anxiety Stress and Reduce Pain Inflammation while Boosting the Immune System.",
  tags: [],
  msrpDollars: 41.57,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:25.301Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
